import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { RootDispatch, RootState } from 'store/types';
import Encryption from 'services/Encryption';
import { billingEncryptionSettingsSelector } from 'store/appSettings/selectors';

export const SHARE_SERVICE_NOW = 'SHARE_SERVICE_NOW';
export const SHARE_SERVICE_NOW_SUCCESS = 'SHARE_SERVICE_NOW_SUCCESS';
export const SHARE_SERVICE_NOW_FAIL = 'SHARE_SERVICE_NOW_FAIL';

export const shareServiceNow = (DTO: any, isGuest?: boolean) => (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  const encryptionSettings = billingEncryptionSettingsSelector(getState());
  const encryptedTicket = Encryption.jsEncrypt(
    encryptionSettings.encryption_algorithm,
    encryptionSettings.encryption_password,
    encryptionSettings.encryption_iv,
    JSON.stringify(DTO)
  );
  return dispatch({
    type: SHARE_SERVICE_NOW,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'post',
        url: getDispatcherUrl(
          '',
          isGuest ? DispatcherAuthPrefix.PUBLIC : DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.SERVICE_NOW,
          DispatcherEndpoint.TICKET
        ),
        headers: {
          [DFDHeaders.mhpAdapter]: AdapterSource.MHP
        },
        data: {
          encryptedTicket
        }
      }
    }
  });
};
